// eslint-disable-next-line import/prefer-default-export
export const API_FEEDBACK = '/mail/send/forFeedback';
export const API_FEEDBACK_ORDERS_NOT_FOUND = '/mail/send/forFeedback/orders-not-found';
export const API_FEEDBACK_COMPLAINTS = '/mail/send/complaints';
export const API_DOWNLOAD_ORDER_TEMPLATE = '/file/download/dogovor-zayavka';
export const API_DOWNLOAD_CONTRACT_TEMPLATE = '/file/download/main-dogovor';
export const API_DOWNLOAD_FUNC_CHARACTERISTICS = '/file/download/func-characteristics-gt2';
export const API_DOWNLOAD_PRIVACY_POLICY = '/file/download/privacy-policy';
export const API_DOWNLOAD_TECH_SUPPORT = '/file/download/tech-support-gt2';
